<template>
  <main-section>
    <card-component  :icon="mdiBookshelf" has-table>
      <ag-grid-vue
        style="width: 100%; height: 50vh"
        class="ag-theme-alpine"
        :defaultColDef="defaultColDef"
        :columnDefs="columnDefs"
        :pagination="true"
        :context="context"
        @grid-ready="onGridReady"
        :rowData="filteredData.value"
      >
      </ag-grid-vue>
    </card-component>
  </main-section>
</template>
<script>
/* eslint-disable */
import axios from "axios";
import { onMounted, ref, reactive, watch, computed } from "vue";
import HeroBar from "@/components/HeroBar";
import TitleBar from "@/components/TitleBar";
import MainSection from "@/components/MainSection";
import CardComponent from "@/components/CardComponent";
import JbButtons from "@/components/JbButtons";
import ButtonActionRender from "@/components/ButtonActionRender";
import Field from "@/components/Field";
import Control from "@/components/Control";
import JbButton from "@/components/JbButton";
import { AgGridVue } from "ag-grid-vue3";
import { useToast } from "vue-toastification";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { useI18n } from "vue-i18n";
import {
  mdiBookshelf,
  mdiCircleEditOutline,
  mdiTrashCan,
  mdiPlusCircleOutline,
  mdiClose,
} from "@mdi/js";
export default {
  components: {
    HeroBar,
    Loading,
    Field,
    Control,
    TitleBar,
    MainSection,
    JbButtons,
    JbButton,
    ButtonActionRender,
    CardComponent,
    AgGridVue,
  },
  props: {
    propCutOff: {
      type: Date,
    },
  },
  setup(props) {
    const { t } = useI18n();
    const isLoading = ref(false);
    const filteredData = reactive({});
    const toast = useToast();
    const columnDefs = [
      {
        headerName: "#",
        valueGetter: "node.rowIndex+1",
        minWidth: 65,
      },
      {
        field: "bank_name",
        headerName: t("Bank"),
        sortable: true,
        filter: true,
        minWidth: 100,
      },
      {
        field: "company_no",
        headerName: t("Company Code"),
        sortable: true,
        filter: true,
        minWidth: 120,
      },
      {
        field: "total_value",
        headerName: t("Amount"),
        sortable: true,
        filter: true,
        minWidth: 150,
        filter: "agNumberColumnFilter",
        type: "rightAligned",
        valueFormatter: (params) =>
          currencyFormatter(params.data.total_value, ""),
      },
    ];

    const refresh = async () => {
      isLoading.value = true;
      const cutoff = new Date(props.propCutOff).toISOString();

      await axios
        .get("payment-recon-detail", { params: { cutoff: cutoff } })
        .then((response) => {
          filteredData.value = response.data.data;
          isLoading.value = false;
        })
        .catch((error) => {
          toast.error(error.response.data, {
            timeout: 5000,
          });
          console.log(error);
          isLoading.value = false;
        });
    };

    // watch(
    //   () => props.propCutOff,
    //   (newVal, oldVal) => {
    //     refresh();
    //   }
    // );

    const defaultColDef = {
      resizable: true,
    };

    const currencyFormatter = (value, sign) => {
      if (typeof value === "string" && value.includes(",")) {
        value = value.replaceAll(",", "");
      }

      if (value !== undefined) {
        const formatted = Number(value)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return sign + formatted;
      }
      return value;
    };

    return {
      mdiBookshelf,
      toast,
      gridApi: null,
      gridColumnApi: null,
      filteredData,
      mdiPlusCircleOutline,
      columnDefs,
      defaultColDef,
      refresh,
      currencyFormatter,
    };
  },
  beforeMount() {
    this.context = {
      componentParent: this,
    };
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      const allColumnIds = [];
      this.gridColumnApi.getAllColumns().forEach((column) => {
        allColumnIds.push(column.colId);
      });
      this.gridColumnApi.autoSizeColumns(allColumnIds, false);
    },
  },
};
</script>
